function getDefaultState() {
    return {
      detalhe_ultima_compra: {},
      produto: {},
      analise:{},
      ultimas_compras: [],
      estoque_filiais: [],
      atualizar_detalhes: 0
    };
  }
  
  const state = getDefaultState();
  
  const getters = {
    getAtualizarDetalhes(state) {
      return state.atualizar_detalhes;
    },
    getUltimaCompra(state) {
        return state.detalhe_ultima_compra;
    },
    getProduto(state) {
        return state.produto;
    },
    getAnalise(state) {
      return state.analise;
    },
    getUltimasCompras(state) {
      return state.ultimas_compras;
    }, 
    getEstoqueFiliais(state) {
      return state.estoque_filiais;
    }
  };
  
  const mutations = {
    setAtualizarDetalhes(state) {
      state.atualizar_detalhes++;
    },
    setUltimaCompra(state, detalhe_ultima_compra) {
        state.detalhe_ultima_compra = detalhe_ultima_compra;
    },
    setProduto(state, produto) {
        state.produto = produto;
    },
    setAnalise(state, analise) {
      state.analise = analise;
    },
    setUltimasCompras(state, ultimas_compras) {
      state.ultimas_compras = ultimas_compras;
    },
    setEstoqueFiliais(state, estoque_filiais) {
      state.estoque_filiais = estoque_filiais;
    }
  };
  
  const actions = {
    setAtualizarDetalhes({commit}) {
      commit('setAtualizarDetalhes');
    },
    setUltimaCompra: ({commit}, detalhe_ultima_compra) => {
      commit('setUltimaCompra', detalhe_ultima_compra);
    },
    setProduto: ({commit}, produto) => {
      commit('setProduto', produto);
    },
    setAnalise: ({commit}, analise) => {
      commit('setAnalise', analise);
    },
    setUltimasCompras: ({commit}, ultimas_compras) => {
      commit('setUltimasCompras', ultimas_compras);
    },
    setEstoqueFiliais: ({commit}, estoque_filiais) => {
      commit('setEstoqueFiliais', estoque_filiais);
    },
    resetDetalhes({commit}){
      commit('setProduto', {});
      commit('setAnalise', {});
      commit('setUltimaCompra', {});
      commit('setUltimasCompras', []);
      commit('setEstoqueFiliais', []);
    }
  };
  
  export default { namespaced: true, state, mutations, getters, actions };
    